module.exports = __webpack_public_path__ + "img/cup-and-pod.de291640.png";